/** InsCoder WANG.J 2025-08-30 B + Compare table section functionality **/

class CustCompareTable extends HTMLElement {
  constructor() {
    super();
    this.isInitialized = false;
  }

  connectedCallback() {
    if (!this.isInitialized) {
      this.init();
      this.isInitialized = true;
    }
  }

  init() {
    this.setupEventListeners();
    this.setupResponsive();
  }

  setupEventListeners() {
    // Add smooth scroll to product links if needed
    const viewButtons = this.querySelectorAll('.cust-compare-table__view-button');
    viewButtons.forEach(button => {
      button.addEventListener('click', this.handleViewButtonClick.bind(this));
    });

    // Handle table responsive behavior
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  handleViewButtonClick(event) {
    // Add any custom analytics or behavior here
    // For now, just let the default link behavior work
    const button = event.currentTarget;
    
    // Add loading state if needed
    button.classList.add('loading');
    
    // Remove loading state after a short delay (if staying on same page)
    setTimeout(() => {
      button.classList.remove('loading');
    }, 1000);
  }

  setupResponsive() {
    this.handleResize();
  }

  handleResize() {
    const tableWrapper = this.querySelector('.cust-compare-table__table-wrapper');
    const rows = this.querySelectorAll('.cust-compare-table__row');
    
    if (tableWrapper && rows.length > 0) {
      // Add scroll hint for mobile if table is scrollable
      if (window.innerWidth <= 1023) {
        const firstRow = rows[0];
        if (firstRow.scrollWidth > firstRow.clientWidth) {
          tableWrapper.classList.add('scrollable');
        } else {
          tableWrapper.classList.remove('scrollable');
        }
      }
    }
  }

  // Method to update comparison data dynamically if needed
  updateComparisonData(data) {
    // This could be used for dynamic content updates
    console.log('Updating comparison data:', data);
  }
}

// Register the custom element
customElements.define('cust-compare-table', CustCompareTable);

// Initialize for sections that might be loaded dynamically
document.addEventListener('DOMContentLoaded', () => {
  const compareTables = document.querySelectorAll('.cust-compare-table');
  compareTables.forEach(table => {
    if (!customElements.get('cust-compare-table')) {
      // Fallback initialization if custom elements aren't supported
      const instance = new CustCompareTable();
      instance.init.call(table);
    }
  });
});

/** InsCoder WANG.J 2025-08-30 E + Compare table section functionality **/